import { memo } from 'react';
export const BundleTooltipContent = memo(({ rewards }) => {
    return (<ul className="w-52 bg-dark-2 shadow animate-slide-up text-xs gap-2 flex flex-col p-2 rounded-xl">
			{rewards.map(reward => (<li key={reward.id}>
					<span className="font-bold">({reward.amount}) {reward.name}</span>
				</li>))}
		</ul>);
});
